import { useRef } from "react";
import { ArrowUpRight } from "@phosphor-icons/react";
import { gsap, useGSAP, MOTION_OK } from "../gsap";
import { CTA_LABEL, INSTAGRAM_URL } from "../content";

type Props = { size?: "md" | "lg"; magnetic?: boolean };

export function CtaButton({ size = "md", magnetic = false }: Props) {
  const ref = useRef<HTMLAnchorElement>(null);

  useGSAP(() => {
    const el = ref.current;
    if (!el || !magnetic) return;
    const mm = gsap.matchMedia();
    mm.add(`${MOTION_OK} and (hover: hover)`, () => {
      const xTo = gsap.quickTo(el, "x", { duration: 0.6, ease: "power3.out" });
      const yTo = gsap.quickTo(el, "y", { duration: 0.6, ease: "power3.out" });
      const move = (e: PointerEvent) => {
        const r = el.getBoundingClientRect();
        xTo((e.clientX - (r.left + r.width / 2)) * 0.3);
        yTo((e.clientY - (r.top + r.height / 2)) * 0.3);
      };
      const leave = () => {
        xTo(0);
        yTo(0);
      };
      el.addEventListener("pointermove", move);
      el.addEventListener("pointerleave", leave);
      return () => {
        el.removeEventListener("pointermove", move);
        el.removeEventListener("pointerleave", leave);
      };
    });
  }, [magnetic]);

  const lg = size === "lg";

  return (
    <a
      ref={ref}
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`group inline-flex items-center whitespace-nowrap rounded-full bg-bone font-medium text-ink transition-colors duration-500 ease-heavy hover:bg-white ${
        lg ? "gap-5 py-2.5 pl-8 pr-2.5 text-lg md:text-xl" : "gap-3 py-1.5 pl-5 pr-1.5 text-sm"
      }`}
    >
      {CTA_LABEL}
      <span
        className={`flex items-center justify-center rounded-full bg-stab text-ink transition-transform duration-500 ease-heavy group-hover:-translate-y-px group-hover:translate-x-0.5 group-hover:scale-105 group-active:scale-90 ${
          lg ? "h-12 w-12" : "h-8 w-8"
        }`}
      >
        <ArrowUpRight weight="light" size={lg ? 24 : 16} />
      </span>
    </a>
  );
}
